import { useIntl } from 'react-intl';

import type { OrderFormPage } from './OrderFormValidation.ts';

type LocationNavbarProps = {
    page: OrderFormPage;
    showLoadingStop: () => void;
    showUnloadingStop: () => void;
    showOrderMaterial: () => void;
    isSubmitted: boolean;
    trigger: () => Promise<boolean>;
};

export const LocationNavbar = ({
    page,
    showLoadingStop,
    showUnloadingStop,
    showOrderMaterial,
    isSubmitted,
    trigger,
}: LocationNavbarProps) => {
    const intl = useIntl();

    const onLoadingStopClick = async () => {
        showLoadingStop();
        if (isSubmitted) {
            await trigger();
        }
    };

    const onUnloadingStopClick = async () => {
        showUnloadingStop();
        if (isSubmitted) {
            await trigger();
        }
    };

    const onMaterialClick = async () => {
        showOrderMaterial();
        if (isSubmitted) {
            await trigger();
        }
    };

    return (
        <div className='nav nav-pills'>
            <ul className='nav nav-pills'>
                <li
                    className={'loadingStop' === page ? 'active' : ''}
                    onClick={() => onLoadingStopClick()}
                    data-testid='loading-stop-tab'
                    key='loading-stop-tab'
                >
                    <div className='display-flex align-items-center gap-5'>
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.navigation.pick-up',

                            defaultMessage: 'Pick-up',
                        })}
                        <span className='rioglyph rioglyph-get' />
                    </div>
                </li>
                <li
                    className={'unloadingStop' === page ? 'active' : ''}
                    onClick={() => onUnloadingStopClick()}
                    data-testid='unloading-stop-tab'
                    key='unloading-stop-tab'
                >
                    <span className='display-flex align-items-center gap-5'>
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.navigation.delivery',

                            defaultMessage: 'Delivery',
                        })}
                        <span className='rioglyph rioglyph-give' />
                    </span>
                </li>
                <li
                    className={'orderMaterial' === page ? 'active' : ''}
                    onClick={() => onMaterialClick()}
                    data-testid='order-material-tab'
                    key='order-material-tab'
                >
                    <span className='display-flex align-items-center gap-5'>
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.navigation.cargo',

                            defaultMessage: 'Cargo',
                        })}
                        <span className='rioglyph rioglyph-palette' />
                    </span>
                </li>
            </ul>
        </div>
    );
};
